module.exports = __webpack_public_path__ + "img/user.a8099917.webp";